module.exports = __webpack_public_path__ + "static/media/help-image-2.a703fa2b.png";